import { Type } from 'class-transformer';
import { IsDate, IsNotEmpty } from 'class-validator';

export class SetSchedulingDate {
  @Type(() => Date)
  @IsDate()
  @IsNotEmpty()
  schedulingDate: Date;

  constructor(date: Date) {
    this.schedulingDate = date;
  }
}
